module.exports = __webpack_public_path__ + "images/3-ru.jpg?v=4479047fcb4d0df4bf2fda725e65c1f8";